var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspireFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E1E9CB98-26A2-4DB4-9A28-2FF3BF970180@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01X---Onboarding",
    transform: "translate(-62.000000, -688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.000000, 688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-3",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 124,
    cy: 124,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "inspire-family",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(16.000000, 54.000000)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0642064,91 C58.0642064,91 88.1518152,72.28585 109.256826,51.1875 C130.361836,30.08005 132,0 132,0 C132,0 101.921492,1.64255 80.8164816,22.74545 C59.7114711,43.84835 41,73.9375 41,73.9375 L58.0642064,91 Z",
    id: "Stroke-8623",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-8625",
    fill: "#FFFFFF",
    points: "41.0769231 74 14 86.4102564 45.5897436 118 58 90.9230769"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8627",
    fill: "#25D086",
    points: "87 71 84.2857143 103.050457 68 120 68 86.1009132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,34.5 C102,37.536 99.536,40 96.5,40 C93.464,40 91,37.536 91,34.5 C91,31.464 93.464,29 96.5,29 C99.536,29 102,31.464 102,34.5 Z",
    id: "Stroke-8629",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.780932,88 C12.5566118,89.0173226 10.4317531,90.4867885 8.47869146,92.4355264 C-0.346253719,101.265886 0.00186143397,131.99807 0.00186143397,131.99807 C0.00186143397,131.99807 30.7354564,132.350742 39.5604016,123.520382 C41.5134632,121.571645 42.9827804,119.446571 44,117.222025",
    id: "Stroke-8633",
    fill: "#FFD67E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,109.370664 C32.787319,111.185828 25.876685,113.281962 18,114 C18.7054418,106.302279 20.5656515,99.3136769 22.3090364,96",
    id: "Stroke-8631",
    fill: "#FFB61A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8635",
    fill: "#25D086",
    points: "61 45 28.9339231 47.7142857 12 64 45.8678463 64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 57.000000)",
    stroke: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 C4.41866667,8 8,11.5813333 8,16",
    id: "Stroke-9048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C8,11.5813333 11.5813333,8 16,8",
    id: "Stroke-9050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C11.5813333,8 8,4.41866667 8,0",
    id: "Stroke-9052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C8,4.41866667 4.41866667,8 0,8",
    id: "Stroke-9054"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(61.000000, 17.000000)",
    stroke: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 C4.41866667,8 8,11.5813333 8,16",
    id: "Stroke-9056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C8,11.5813333 11.5813333,8 16,8",
    id: "Stroke-9058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C11.5813333,8 8,4.41866667 8,0",
    id: "Stroke-9060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C8,4.41866667 4.41866667,8 0,8",
    id: "Stroke-9062"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(55.000000, 0.000000)",
    stroke: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 0,
    x2: 3,
    y2: 6,
    id: "Stroke-9064"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3,
    x2: 6,
    y2: 3,
    id: "Stroke-9066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(39.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0.896956857 L13.0148305,4.90157935 L10.3522727,9.41063174 L8.0385208,11.4670647 L3.74191063,13.4657165 L3.74191063,14.3773112 L6.15080894,15.6059322 L9.23844376,17.5600924 L11.7692604,20.5832049 L13.6901002,24.8068182 L16.566641,20 C18.7814587,17.7303544 19.8888675,16.5955316 19.8888675,16.5955316 C19.8888675,16.5955316 21.5573318,15.7303544 24.8942604,14 L22,12.8518875 L18.4112096,10.2669492 L15.8280046,7 L14,0.896956857 Z",
    id: "Path-10",
    fill: "#FFD67E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14 C7.7336,14 14,20.2692 14,28",
    id: "Stroke-9070",
    stroke: "#FFD67E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,28 C14,20.2692 20.2664,14 28,14",
    id: "Stroke-9072",
    stroke: "#FFD67E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,14 C20.2664,14 14,7.7308 14,0",
    id: "Stroke-9074",
    stroke: "#FFD67E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C14,7.7308 7.7336,14 0,14",
    id: "Stroke-9076",
    stroke: "#FFD67E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 124,
    cy: 222,
    rx: 50,
    ry: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspireFamily);
export default __webpack_public_path__ + "static/media/inspire-family.ca089112ef4fd99c9f5f235c186fe073.svg";
export { ForwardRef as ReactComponent };